import React, { useState } from "react"
import { Link } from "react-router-dom"
import { blog } from "../../../dummydata"
import { getImageUrl } from "../../../config/s3Config"
import "./footer.css"

const Footer = () => {
  const [email, setEmail] = useState('')
  const [isMobile, setIsMobile] = useState(false)

  // Check if device is mobile on component mount and resize
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const handleNewsletterSubmit = (e) => {
    e.preventDefault()
    if (email.trim()) {
      // Handle newsletter subscription
      console.log('Newsletter subscription:', email)
      setEmail('')
    }
  }

  return (
    <>
      <section className='newsletter-section'>
        <div className='container'>
          <div className='newsletter-content'>
            <div className='newsletter-text'>
              <h2>Stay Updated with Our Newsletter</h2>
              <p>Get the latest updates on courses, events, and educational insights delivered to your inbox.</p>
            </div>
            <form className='newsletter-form' onSubmit={handleNewsletterSubmit}>
              <div className={`input-group ${isMobile ? 'mobile-layout' : ''}`}>
                <input 
                  type='email' 
                  placeholder='Enter your email address' 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={isMobile ? 'mobile-input' : ''}
                />
                <button type='submit' className={`subscribe-btn ${isMobile ? 'mobile-btn' : ''}`}>
                  <i className='fa fa-paper-plane'></i>
                  <span className={isMobile ? 'mobile-text' : ''}>Subscribe</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <footer className='footer-main'>
        <div className='container'>
          <div className='footer-content'>
            <div className='footer-section brand-section'>
              <div className='footer-logo'>
                <img src={getImageUrl("/images/logos/sdti.png")} alt="SDTI Logo" />
                <div className='logo-text'>
                  <h3>SDTI</h3>
                  <span>Skill Development & Training Institute</span>
                </div>
              </div>
              <p className='brand-description'>
                Empowering individuals with quality education and professional training to build successful careers in the modern world.
              </p>
              <div className='social-links'>
                <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer" className='social-link'>
                  <i className='fab fa-facebook-f'></i>
                </a>
                <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className='social-link'>
                  <i className='fab fa-instagram'></i>
                </a>
                <a href="https://twitter.com" aria-label="Twitter" target="_blank" rel="noopener noreferrer" className='social-link'>
                  <i className='fab fa-twitter'></i>
                </a>
                <a href="https://youtube.com" aria-label="YouTube" target="_blank" rel="noopener noreferrer" className='social-link'>
                  <i className='fab fa-youtube'></i>
                </a>
                <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer" className='social-link'>
                  <i className='fab fa-linkedin-in'></i>
                </a>
              </div>
            </div>

            <div className='footer-section'>
              <h4>Quick Links</h4>
              <ul className='footer-links'>
                <li><Link to='/' className='footer-link'>Home</Link></li>
                <li><Link to='/about' className='footer-link'>About Us</Link></li>
                <li><Link to='/courses' className='footer-link'>Schools</Link></li>
                <li><Link to='/team' className='footer-link'>Our Team</Link></li>
                <li><Link to='/pricing' className='footer-link'>Pricing</Link></li>
                <li><Link to='/contact' className='footer-link'>Contact</Link></li>
              </ul>
            </div>

            <div className='footer-section'>
              <h4>Programs</h4>
              <ul className='footer-links'>
                <li><Link to='/courses' className='footer-link'>IT Programs</Link></li>
                <li><Link to='/courses' className='footer-link'>Nursing Programs</Link></li>
                <li><Link to='/courses' className='footer-link'>Teaching Programs</Link></li>
                <li><Link to='/courses' className='footer-link'>Online Courses</Link></li>
                <li><Link to='/courses' className='footer-link'>Certification</Link></li>
                <li><Link to='/courses' className='footer-link'>Workshops</Link></li>
              </ul>
            </div>

            <div className='footer-section'>
              <h4>Support</h4>
              <ul className='footer-links'>
                <li><Link to='/contact' className='footer-link'>Help Center</Link></li>
                <li><Link to='/contact' className='footer-link'>Student Portal</Link></li>
                <li><Link to='/contact' className='footer-link'>Career Guidance</Link></li>
                <li><Link to='/contact' className='footer-link'>FAQs</Link></li>
                <li><Link to='/contact' className='footer-link'>Feedback</Link></li>
                <li><Link to='/contact' className='footer-link'>Report Issue</Link></li>
              </ul>
            </div>

            <div className='footer-section contact-section'>
              <h4>Contact Info</h4>
              <div className='contact-info'>
                <div className='contact-item'>
                  <i className='fa fa-map-marker-alt contact-icon'></i>
                  <div className='contact-details'>
                    <p>No: 109 Peradeniya Rd</p>
                    <p>Kandy 20000</p>
                  </div>
                </div>
                <div className='contact-item'>
                  <i className='fa fa-phone-alt contact-icon'></i>
                  <div className='contact-details'>
                    <p>076 999 8889</p>
                    <p>072 260 44 77</p>
                    <p>072 928 3616</p>
                  </div>
                </div>
                <div className='contact-item'>
                  <i className='fa fa-envelope contact-icon'></i>
                  <div className='contact-details'>
                    <p>info@sdti.lk</p>
                    <p>admissions@sdti.lk</p>
                  </div>
                </div>
                <div className='contact-item'>
                  <i className='fa fa-clock contact-icon'></i>
                  <div className='contact-details'>
                    <p>Mon - Fri: 8:00 AM - 5:00 PM</p>
                    <p>Sat &amp; Sun: 8:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className='footer-bottom'>
        <div className='container'>
          <div className='footer-bottom-content'>
            <div className='copyright'>
              <p>&copy; 2024 SDTI. All rights reserved.</p>
            </div>
            <div className='legal-links'>
              <Link to='/privacy' className='legal-link'>Privacy Policy</Link>
              <Link to='/terms' className='legal-link'>Terms of Service</Link>
              <Link to='/cookies' className='legal-link'>Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
